import {sendRequest, serializeObject} from '@js/utils';

export function lazyloadRows(pageParam, $showSliceBtn, rankingId = 0) {
    const $rankingResultsContainer = $('.ranking-results');
    const offset = parseInt($rankingResultsContainer.attr('data-offset'), 10);
    const queryParams = `${pageParam}&${serializeObject({offset})}`;
    return new Promise((resolve) => {
        $showSliceBtn.text('Загрузка ...')
            .addClass('loading-cursor')
            .prop('disabled', true);
        sendRequest('get', `/ratings/getRankingSlice?${queryParams}`, {}, (res) => {
            const success = typeof res !== 'undefined' && res.hasOwnProperty('success') && res.success;
            if (success && res?.data?.html) {
                const scrollPosition = $(window)
                    .scrollTop();
                const isLastSlice = res.data.is_last_slice;
                $('.ranking-results .ranking-tiles').append(res.data.html);
                $(window).scrollTop(scrollPosition);
                if (isLastSlice) {
                    $showSliceBtn.closest('.show-next-slice-ranking-container').remove();
                } else {
                    $showSliceBtn.text('Показать ещё').removeClass('loading-cursor').prop('disabled', false);
                }
                $rankingResultsContainer.attr('data-offset', res.data.offset);
                resolve();
            } else {
                $showSliceBtn.text('Произошла ошибка');
            }
        });
    });
}
